export default __webpack_public_path__ + "static/media/HelpQuestionmarkicon.a0132edc.svg";